import { render } from "./ModuleContext.vue?vue&type=template&id=8685a4be&scoped=true&ts=true"
import script from "./ModuleContext.vue?vue&type=script&lang=ts"
export * from "./ModuleContext.vue?vue&type=script&lang=ts"

import "./ModuleContext.vue?vue&type=style&index=0&id=8685a4be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8685a4be"]])

export default __exports__